import { useSelector } from 'react-redux';
import { chatWidgetTroubleshootingLastResultSelector } from '@mm/state/selectors/chatWidgetTroubleshootingSelectors';
import { Result } from '../ChatWidgetTroubleshootingToolResult';

export const useDetectedChatWidget = (): Result => {
  const result = useSelector(chatWidgetTroubleshootingLastResultSelector);

  if (result?.widgets?.fbCustomerChat && result.widgets.webchat) {
    return {
      result: 'info',
      description: 'Detected active omnichat widget',
    };
  }

  if (result?.widgets?.webchat) {
    return {
      result: 'info',
      description: 'Detected active webchat widget',
    };
  }

  if (result?.widgets?.fbCustomerChat) {
    return {
      result: 'info',
      description: 'Detected active Facebook Customer Chat widget',
    };
  }
};
